import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './style.scss'
import { Scrollchor, swing } from 'react-scrollchor'
import clsx from 'clsx'

export const Menu = ({ activeYear, entries }) => {
  return (
    <div className='yearMenu'>
      {browserCheck.isMobile ? (
        <>
          <div className='ui five item attached menu'>
            {entries.map((value, index) => {
              if (index % 2 !== 0 && value.idx !== 2000) {
                return (
                  <Scrollchor
                    key={`${value.idx}`}
                    to={`#${value.idx}`}
                    animate={{ offset: -110, duration: 1000, easing: swing }}
                    className={clsx('item')}
                    style={{
                      color: activeYear === value.idx ? '#1d5f82' : 'black',
                      fontWeight: activeYear === value.idx ? '800' : '500',
                      backgroundColor: 'transparent'
                    }}
                  >
                    {value.idx}
                  </Scrollchor>
                )
              }
            })}
          </div>
          <div className='ui five item attached menu'>
            {entries.map((value, index) => {
              if (index % 2 === 0 && value.idx !== 2000) {
                return (
                  <Scrollchor
                    key={`${value.idx}`}
                    to={`#${value.idx}`}
                    animate={{ offset: -110, duration: 1000, easing: swing }}
                    className={clsx('item')}
                    style={{
                      color: activeYear === value.idx ? '#1d5f82' : 'black',
                      fontWeight: activeYear === value.idx ? '800' : '500',
                      backgroundColor: 'transparent'
                    }}
                  >
                    {value.idx}
                  </Scrollchor>
                )
              }
            })}
          </div>
        </>
      ) : (
        <div className='ui ten item attached menu'>
          {entries.map((value, index) => {
            if (value.idx !== 2000) {
              return (
                <Scrollchor
                  key={`${value.idx}`}
                  to={`#${value.idx}`}
                  animate={{ offset: -70, duration: 1000, easing: swing }}
                  className={clsx('item', activeYear === value.idx && 'active')}
                  style={{
                    color: activeYear === value.idx ? '#1d5f82' : 'black',
                    fontWeight: activeYear === value.idx ? '800' : '500',
                    backgroundColor:
                      activeYear === value.idx ? '#F0F0F2' : 'transparent'
                  }}
                >
                  {value.idx}
                </Scrollchor>
              )
            }
          })}
        </div>
      )}
    </div>
  )
}
